<template>
	<div class = "pay-code-div">
		<van-field  clearable center v-model = "code" label-width="60" type="digit"  input-align="left" @input="changeInput" label="验证码" placeholder="请输入短信验证码" maxlength="6">
		 <template #button>
		    <van-button plain round size="small" type="primary" :disabled="codeMsg != '获取验证码'" @click="getCode()">{{codeMsg}}</van-button>
		  </template>
		</van-field>
	</div>
</template>

<script>
	import {Field,Button,Notify} from 'vant';
	import { smsSend,relieveBound,bound } from '@/request/api';
	export default {
		name: 'PayCode',
		components: {
		      [Field.name]: Field,
		      [Button.name]: Button,
		      [Notify.name]: Notify,
		      
		 },
		 watch:{
			phone(val){
				if(!val){
					this.stopCodeTimer()
				}
			},
			count(val){
				if(val>0){
					if(this.codeMsg = '获取验证码'){
						this.getCode()
					}
				}
			}
		 },
		 props:['phone'],
		 data(){
			return {
				code:'',
				codeMsg:'获取验证码',
				codeTime:60,
				codeTimer:''
			}
		},
		methods:{
			changeInput(code){
				this.$emit('setCode',code)
			},
			//获取验证码
			getCode(){
				
				//发送短信
				if(!this.phone || this.phone.length != 11){
					this.showCode = false;
					Notify({ type: 'danger', message: '手机号格式错误' });
				}else{
					//开启定时器
					this.codeMsg = this.codeTime + "秒后重试";
					this.codeTimer = setInterval(this.reduceTime, 1000);
					this.sendCode(this.phone);
				}
				
			},
			//axios获取验证码
			sendCode(phone){
				smsSend({
					mobile:	phone	  
				}).then(res => {
					Notify({ type: 'success', message: '验证码已发送' });					  
				}) 
			},
			//定时器-验证码
			reduceTime(){
				this.codeTime --;
				if(this.codeTime == 0){
					this.stopCodeTimer();
				}else{
					this.codeMsg = this.codeTime + "秒后重试";
				}
				
			},
			
			stopCodeTimer(){
				clearInterval(this.codeTimer);
				this.codeTime = 60;
				this.codeMsg = "获取验证码";
			}
		}
	}
</script>

<style>
	.pay-code-div .van-field__label {
		color: #2d2d2d;
		font-size: 15px;
	}
	
	.pay-code-div .van-button {
		width: auto;
		height: auto;
		margin: 0;
		padding: 8px;
		font-size: 13px;
	}
</style>
